import {CaseDetails} from 'ApplicationEntry/models/CaseDetails';
import {isValidPolicyNumberPaperElectronic} from 'ApplicationEntry/models/EnteredPolicyNumber';
import {CriticalIllnessPlanType} from 'ApplicationEntry/models/ProductsRiders/PlanTypes';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import * as BAActions from 'ApplicationEntry/ducks/billingAgent';
import States from 'ApplicationEntry/models/States';
import * as ErrorMessages from '../../ErrorMessages';
import '.././Ordinary/CriticalIllness.sass';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import {CriticalIllnessNY} from 'ApplicationEntry/models/ProductsRiders/CriticalIllnessNY/CriticalIllnessNY';
import PackageSelect from '../PackageSelect';
import * as AIPActions from 'ApplicationEntry/ducks/ProductsRiders/aip';
import * as AActions from 'ApplicationEntry/ducks/ProductsRiders/accident';
import * as ANYActions from 'ApplicationEntry/ducks/ProductsRiders/accidentNewYork';
import * as PActions from 'ApplicationEntry/ducks/ProductsRiders/pinCare';
import * as CIActions from 'ApplicationEntry/ducks/ProductsRiders/criticalIllness';
import * as CINYActions from 'ApplicationEntry/ducks/ProductsRiders/criticalIllnessNY';
import * as GWLActions from 'ApplicationEntry/ducks/ProductsRiders/iwl';
import * as GLTActions from 'ApplicationEntry/ducks/ProductsRiders/glterm';
import * as GULActions from 'ApplicationEntry/ducks/ProductsRiders/universalLife';
import * as SActions from 'ApplicationEntry/ducks/ProductsRiders/shop';
import * as DActions from 'ApplicationEntry/ducks/ProductsRiders/disability';
import * as CActions from 'ApplicationEntry/ducks/ProductsRiders/cancer';

type CriticalIllnessNYProps = {
  caseDetails: CaseDetails;
  criticalIllnessNY: CriticalIllnessNY;
};

const GroupCriticalIllnessNY = (props: CriticalIllnessNYProps) => {
  const stateList = States;
  const dispatch = useDispatch();
  const {
    planType,
    insuredSC,
    calculatedPremium,
    spouseSC,
    benefitAmount,
    cwa,
    policyNumber,
    replacement,
    section125,
    packageSource,
    wellnessUnits,
    ciOption,
    secondEventCI,
    jStamp,
    situsState,
    packageSourceList,
  } = props.criticalIllnessNY;

  const [planTypeBlurred, setBlurPlanType] = useState(false);
  const [policyNumberBlurred, setPolicyNumberBlurred] = useState(false);
  const showPlanTypeError = planTypeBlurred && planType.key === 'Empty';
  const [planTypeLabel, setPlanTypeLabel] = useState<HTMLLabelElement | null>();
  const [wellnessUnitsLabel, setWellnessUnitsLabel] = useState<HTMLLabelElement | null>();
  const [smokerLabel, setSmokerLabel] = useState<HTMLLabelElement | null>();
  const [situsStateLabel, setSitusStateLabel] = useState<HTMLLabelElement | null>();

  const showPolicyNumberError = policyNumberBlurred && !isValidPolicyNumberPaperElectronic(policyNumber) && replacement;

  useEffect(() => {
    const caseNumber = props.caseDetails.key === 'ValidGroupCaseDetails' ? props.caseDetails.caseNumber.Data : '';

    dispatch(CINYActions.getPackageSourceList(caseNumber, 'GVCIP2NY'));
  }, []);

  const getHeader = (header1: string, header2: string) => {
    return (
      <div className="disability-section">
        <div className="disability-section__sub-title-container">
          <Typography variant="subtitle2" color="primary" className="disability-section__sub-title-container-title ">
            {header1}
          </Typography>
        </div>
        {header2 !== '' ? (
          <div className="disability-section__sub-title-container">
            <Typography variant="subtitle2" color="primary" className="disability-section__sub-title-container-title">
              {header2}
            </Typography>
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <>
      <div className="critical-illness-section" id="critical-illness-section">
        <form noValidate autoComplete="off" className="critical-illness-section__form">
          <div className="critical-illness-section__form-row">
            <Grid container spacing={4}>
              <Grid item xs={12} md={4}>
                <FormControl
                  error={showPlanTypeError}
                  variant="outlined"
                  className="critical-illness-section__form-text-field"
                >
                  <InputLabel ref={setPlanTypeLabel} id="critical-illness-plantype-label">
                    Plan Type
                  </InputLabel>
                  <Select
                    labelId="critical-illness-label-plantype"
                    labelWidth={planTypeLabel?.clientWidth}
                    id="critical-illness-plantype"
                    value={planType.key === 'Empty' ? '' : planType.value}
                    onBlur={() => setBlurPlanType(true)}
                    onChange={e => {
                      dispatch(CINYActions.changePlanType(e.target.value as string));
                      if (e.target.value !== 'FAMILY') {
                        dispatch(CINYActions.changeSpouseSC(''));
                      }
                    }}
                    displayEmpty
                  >
                    {CriticalIllnessPlanType.map(plan => (
                      <MenuItem value={plan.value} key={plan.value}>
                        {plan.key}
                      </MenuItem>
                    ))}
                  </Select>
                  {showPlanTypeError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl variant="outlined" className="critical-illness-section__form-text-field">
                  <InputLabel ref={setSmokerLabel} id="critical-illness-insuredsc-label">
                    Insured Smoking Code
                  </InputLabel>
                  <Select
                    labelId="critical-illness-label-insuredsc"
                    labelWidth={smokerLabel?.clientWidth}
                    id="critical-illness-insuredsc"
                    value={insuredSC.key === 'Empty' ? '' : insuredSC.value}
                    onChange={e => {
                      dispatch(CINYActions.changeInsuredSC(e.target.value as string));
                    }}
                    displayEmpty
                  >
                    <MenuItem value="Smoker">Smoker</MenuItem>
                    <MenuItem value="Non Smoker">Non Smoker</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl variant="outlined" className="critical-illness-section__form-text-field" disabled={true}>
                  <InputLabel ref={setSmokerLabel} id="critical-illness-spousesc-label">
                    Spouse Smoking Code
                  </InputLabel>
                  <Select
                    labelId="critical-illness-label-spousesc"
                    labelWidth={smokerLabel?.clientWidth}
                    id="critical-illness-spouse-sc"
                    value={spouseSC.key === 'Empty' ? '' : spouseSC.value}
                    onChange={e => dispatch(CINYActions.changeSpouseSC(e.target.value as string))}
                    displayEmpty
                    disabled={planType.value === 'FAMILY' || planType.value === 'INDSPS' ? false : true}
                  >
                    <MenuItem value="Smoker">Smoker</MenuItem>
                    <MenuItem value="Non Smoker">Non Smoker</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <PackageSelect
                packageName={packageSource}
                packageList={packageSourceList}
                changePackageAction={CINYActions.changePackageSource}
                handlePackageItems={(packageItem: object) => {
                  dispatch(CINYActions.changeBenefitAmount(packageItem['benefitAmt'] as number));
                  dispatch(CINYActions.changeWellnessUnits(packageItem['wellness'] as string));
                  if (packageItem['cancer'] === 'Y') {
                    dispatch(CINYActions.changeCIOption(true));
                  } else {
                    dispatch(CINYActions.changeCIOption(false));
                  }
                  if (packageItem['recurrence'] === 'Y') {
                    dispatch(CINYActions.changeSecondEventCI(true));
                  } else {
                    dispatch(CINYActions.changeSecondEventCI(false));
                  }
                }}
              />

              <Grid item xs={12} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="checkedB"
                      color="secondary"
                      id="critical-illness-section125"
                      checked={section125}
                      onChange={() => dispatch(CINYActions.changeSection125(!section125))}
                    />
                  }
                  label={<Typography>Section 125</Typography>}
                  className="critical-illness-section__form-text-field"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="critical-illness-premium"
                  label="Premium"
                  variant="outlined"
                  placeholder="Enter Premium"
                  margin="normal"
                  fullWidth
                  className="critical-illness-section__form-text-field"
                  value={calculatedPremium.value}
                  onChange={event => {
                    dispatch(CINYActions.changePremium(event.target.value as string));
                    dispatch(CINYActions.changeCalculatedPremium(event.target.value as string));
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="critical-illness-cwa"
                  label="CWA"
                  variant="outlined"
                  placeholder="Enter CWA"
                  margin="normal"
                  fullWidth
                  className="critical-illness-section__form-text-field"
                  value={cwa.value}
                  onChange={e => dispatch(CINYActions.changeCWA(e.target.value as string))}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="critical-illness-benefit-amt"
                  label="Benefit Amount"
                  variant="filled"
                  placeholder="Enter Benefit Amount"
                  margin="normal"
                  fullWidth
                  className="critical-illness-section__form-text-field"
                  value={benefitAmount}
                  onChange={e => dispatch(CINYActions.changeBenefitAmount(parseInt(e.target.value, 10)))}
                  disabled
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="secondary"
                      checked={jStamp}
                      onChange={() => dispatch(CINYActions.changeJStamp(!jStamp))}
                      name="checkedJStamp"
                      disabled
                    />
                  }
                  label={<Typography>J-Stamp</Typography>}
                  className="critical-illness-section__form-text-field"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="checkedB"
                      color="secondary"
                      id="critical-illness-replacement"
                      checked={replacement}
                      onChange={() => {
                        setPolicyNumberBlurred(true);
                        dispatch(CINYActions.changeReplacement(!replacement));
                      }}
                    />
                  }
                  label={<Typography className="case-details-section__checkbox-label">Replacement</Typography>}
                  className="critical-illness-section__form-text-field"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="critical-illness-policy-number"
                  label="Policy Number"
                  variant="outlined"
                  placeholder="Enter Policy Number"
                  margin="normal"
                  fullWidth
                  error={showPolicyNumberError}
                  helperText={showPolicyNumberError ? ErrorMessages.INVALID_POLICY_NUMBER : ''}
                  className="critical-illness-section__form-text-field"
                  value={policyNumber.key !== 'ValidPolicyNumber' || !replacement ? '' : policyNumber.value.value}
                  onBlur={() => setPolicyNumberBlurred(true)}
                  onChange={e => dispatch(CINYActions.changePolicyNumber(e.target.value as string))}
                  disabled={!replacement}
                  inputProps={{
                    maxLength: 10,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl variant="outlined" className="disability-section__form-text-field">
                  <InputLabel ref={setSitusStateLabel} id="disability-situs-state-label">
                    Situs State
                  </InputLabel>
                  <Select
                    labelId="disability-label-situs-state"
                    labelWidth={situsStateLabel?.clientWidth}
                    id="disability-situs-state"
                    value={situsState.value}
                    onChange={e => {
                      dispatch(BAActions.changeState(e.target.value as string));
                      dispatch(CINYActions.changeSitusState(e.target.value as string));
                    }}
                    displayEmpty
                  >
                    {stateList.map(stateCode => (
                      <MenuItem key={stateCode} value={stateCode}>
                        {stateCode}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <div className="critical-illness-section__form-row">
              {getHeader('Options', '')}

              <Grid container spacing={4}>
                <Grid item xs={12} md={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="secondary"
                        checked={ciOption}
                        onChange={() => dispatch(CINYActions.changeCIOption(!ciOption))}
                        name="checkedCancer"
                        disabled
                      />
                    }
                    label={<Typography>CI</Typography>}
                    className="disability-section__form-text-field"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="secondary"
                        checked={secondEventCI}
                        onChange={() => dispatch(CINYActions.changeSecondEventCI(!secondEventCI))}
                        name="checkedRecurrence"
                        disabled
                      />
                    }
                    label={<Typography>2ns Event CI</Typography>}
                    className="disability-section__form-text-field"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl variant="outlined" className="critical-illness-section__form-text-field">
                    <InputLabel ref={setWellnessUnitsLabel} id="critical-illness-insuredsc-label">
                      Wellness Units
                    </InputLabel>
                    <Select
                      labelId="critical-illness-label-insuredsc"
                      labelWidth={wellnessUnitsLabel?.clientWidth}
                      id="critical-illness-insuredsc"
                      value={wellnessUnits.value}
                      onChange={e => {
                        dispatch(CINYActions.changeWellnessUnits(e.target.value as string));
                      }}
                      displayEmpty
                      disabled
                    >
                      <MenuItem value="1">1</MenuItem>
                      <MenuItem value="2">2</MenuItem>
                      <MenuItem value="3">3</MenuItem>
                      <MenuItem value="4">4</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default GroupCriticalIllnessNY;
